import { render, staticRenderFns } from "./ArtistList.vue?vue&type=template&id=779a6360&scoped=true&"
import script from "./ArtistList.vue?vue&type=script&lang=js&"
export * from "./ArtistList.vue?vue&type=script&lang=js&"
import style0 from "./ArtistList.vue?vue&type=style&index=0&id=779a6360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779a6360",
  null
  
)

export default component.exports